export enum Months {
  JANUARY = 'Januar',
  FEBRUARY = 'Februar',
  MARCH = 'März',
  APRIL = 'April',
  MAY = 'Mai',
  JUNE = 'Juni',
  JULY = 'Juli',
  AUGUST = 'August',
  SEPTEMBER = 'September',
  OCTOBER = 'Oktober',
  NOVEMBER = 'November',
  DECEMBER = 'Dezember',
}
